var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.flex)?_c('div',{staticClass:"tree-column",class:{border: _vm.border!== undefined},style:({ width: _vm.width + 'px', flex: _vm.flex})},[_vm._t("default")],2):_c('div',{staticClass:"tree-column",class:{border: _vm.border!== undefined},style:({ width: _vm.width + 'px'})},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f29252e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/system-manage/lib/column.vue
// module id = null
// module chunks = 